var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 20 20","width":"20","height":"20"}},[_c('path',{attrs:{"stroke":"#121212","stroke-width":"1.5","d":"M12.394 16.965l-1.209-1.449a10.75 10.75 0 0 0-4.53-3.196l-2.638-.973 11.1-6.746-2.723 12.364z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }